module.exports = __webpack_public_path__ + "img/warning-circle.bea067c1.svg";